import { SelectOption } from 'modules/forms'

import { SupervisorPersonDtoSchema } from '../../../schemas'
import { BonusPeriodListItemDto, OrganizationUnitGetDto } from '../../admin/models'
import { User } from '../../auth'
import { DepartmentLookup, LookupItem, LookupLanguages } from '../../core'
import { CommentGetDto, GoalActivityListItemDto, GoalActivityListItemType } from '../../front-face/models'
import { isBlank, isEmpty, OrgChartDto, TeamPersonApiGetDto, UserViewGetDto } from '../../shared'

export function mapLookupItemsToSelectOptions(lookup: LookupItem[]) {
  if (isBlank(lookup)) {
    return []
  }

  return lookup.map((lookupItem) => {
    return {
      text: lookupItem.value,
      value: lookupItem.id,
    } as SelectOption
  })
}

export function mapBonusPeriodsToSelectOptions(bonusPeriods: BonusPeriodListItemDto[]) {
  if (isBlank(bonusPeriods)) {
    return []
  }

  return [...bonusPeriods].sort((a, b) => b.name.localeCompare(a.name)).map((bonusPeriod) => {
    return {
      text: bonusPeriod.name,
      value: bonusPeriod.bonusPeriodId,
    } as SelectOption
  })
}

export function mapOrgsToSelectOptions(organizations: OrganizationUnitGetDto[]) {
  if (isBlank(organizations)) return []

  return organizations.map((organization) => {
    return {
      text: organization.name,
      value: organization.organizationUnitId,
    } as SelectOption
  })
}

export function mapSupervisorsToOrgChart(supervisors: SupervisorPersonDtoSchema[]): OrgChartDto[] {
  if (isBlank(supervisors)) return []

  return supervisors.map((supervisor) => {
    return {
      displayName: supervisor.supervisorPersonDisplayName,
      function: supervisor.supervisorPersonTitle,
      id: supervisor.supervisorPersonId,
    }
  })
}

export function mapUserToUserView(user: User): UserViewGetDto {
  return {
    department: user.department,
    function: user.function,
    division: user.division,
    imageUrls: user.imageUrls,
    userDisplayName: user.userDisplayName,
  } as UserViewGetDto
}

export function mapTeamUserToUserView(user: TeamPersonApiGetDto): UserViewGetDto {
  return {
    department: user.department,
    function: user.function,
    division: user.division,
    imageUrls: user.imageUrls,
    userDisplayName: user.userDisplayName,
  } as UserViewGetDto
}

export function mapCommentToActivityListItem(comment: CommentGetDto): GoalActivityListItemDto {
  return {
    created: comment.created,
    id: comment.commentId,
    text: comment.text,
    type: GoalActivityListItemType.Comment,
    stateId: 0,
    relatedPerson: {
      id: comment.commentedById!,
      displayName: comment.commentedByName,
      imageUrls: comment.imageUrls,
    },
  } as GoalActivityListItemDto
}

export function mapLanguageToSelectItem(languages: LookupLanguages[]) {
  return languages.map((language) => {
    return {
      text: language.name,
      value: language.id,
    }
  })
}

export function filterAndMapDepartmentByOrganization(
  departments: DepartmentLookup[],
  organizationId: string | undefined = ''
) {
  if (isEmpty(organizationId)) return mapDepartmentToSelectOption(departments)
  const organizationUnitId = Number(organizationId)

  return mapDepartmentToSelectOption(
    departments.filter((department) => department.organizationUnitId === organizationUnitId)
  )
}

function mapDepartmentToSelectOption(departments: DepartmentLookup[]) {
  return departments.map((department) => {
    return {
      text: department.name,
      value: department.id,
    }
  })
}



// WEBPACK FOOTER //
// ./src/app/shared/form-utils/mapper.ts